import Icon from '@bugbug/core/components/Icon';
import styled from 'styled-components';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`;

export const SubscriptionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SubscriptionCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid ${(props) => props.theme.colors.border.medium};
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  padding: 26px 43px 29px 33px;
`;

export const ChevronDownIcon = styled(Icon).attrs({
  name: 'chevronDown',
  width: 11,
  height: 11,
})`
  margin-top: 2px;
  margin-left: 10px;
  fill: ${(props) => props.theme.colors.common.white};
`;

export const PlanName = styled.p`
  display: flex;
  align-items: center;
  gap: 7px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1.5;
  font-weight: ${(props) => props.theme.fontWeight.bold};
`;

export const SubscriptionDetails = styled.div`
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(4, fit-content(100%));
  grid-column-gap: 40px;
  grid-template-rows: repeat(2, 1fr);
  grid-row-gap: 4px;
`;

export const DetailsHeader = styled.p`
  line-height: 1.5;
  font-weight: ${(props) => props.theme.fontWeight.regular};
  color: ${(props) => props.theme.colors.text.secondary};
  margin: 0;
`;

export const DetailsValue = styled(DetailsHeader)`
  font-weight: ${(props) => props.theme.fontWeight.bold};
  color: ${(props) => props.theme.colors.text.normal};
`;

export const ManageButtonContainer = styled.div`
  margin-bottom: 9px;
`;
